import PropTypes from 'prop-types';
import Presenter from 'utils/PropTypesPresenter';

export default new Presenter(
  {
    hasBidRequest: PropTypes.bool,
  },
  {},
);



// WEBPACK FOOTER //
// ./src/presenters/MyBundlePresenter.js